import { resolveDisplayLocale } from '~/utils/resolveDisplayLocale'

/**
 * useCurrency
 */
export function toCurrency(val?: number | string, currency = 'USD', locale = 'en') {
  const formatter = new Intl.NumberFormat(resolveDisplayLocale(locale), {
    style: 'currency',
    currency
  })

  return isNaN(Number(val)) ? formatter.format(0) : formatter.format(Number(val))
}
